import pubsub from "@viewlift/pubsub"
import localforage from "localforage"
import { lockIcon } from "../../../images/icon"
import { fetchHbaData } from "../../components/GeoLocate/helper"
import { handleSeviceTypes, switchBetweenPages, getFaqLink } from "../../helpers"
import { createDecisionsAuthorize } from "../../components/AdobeRestV2/Apis"
import logger from "../../logger"

let modalsArray = []
let videoContainer = null
let detailPageContainer = null
const parseSvgString = svgString =>new DOMParser().parseFromString(svgString, 'image/svg+xml').querySelector('svg');

//gets the current browser
export const detectBrowser = () => {
  if ((navigator.userAgent.indexOf("Edg") > -1) && (window.navigator?.userAgentData?.platform != 'macOS')) {
    return 'IE';
  }
  else if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
    return 'Opera';
  } else if (navigator.userAgent.indexOf("Chrome") != -1) {
    return 'Chrome';
  } else if (navigator.userAgent.indexOf("Safari") != -1) {
    return 'Safari';
  } else if (navigator.userAgent.indexOf("Firefox") != -1) {
    return 'Firefox';
  } else {
    return 'Unknown';
  }
}

const watchLiveSecurityWall = async (VLPlayerCore, playerId, navigate, metadataMap, modalType, contentPlanIds, isPlayable) => {
  let isDash = detectBrowser() === "Safari";
  const {backgroundColor, border, textColor} =  window?.app_data?.appcmsMain?.brand?.cta?.primary
  let videoWrapper = document.getElementsByClassName("error-wall-wrapper")
  if (!videoWrapper?.length) {
    videoWrapper = document.getElementsByClassName("video-js videoEl")
  }
  let vlContainer = document.querySelector(`.${detailPageContainer}`)
  if (!isPlayable) {
    videoWrapper = document.getElementsByClassName(videoContainer)
  }
  let securityWall = document.createElement("div")
  let securityMessage = document.createElement("h1")
  let tveLoginBtn = document.createElement("div")
  let getStartedBtn = document.createElement("div")
  let lockIconDiv = document.createElement("div");
  lockIconDiv.appendChild(parseSvgString(lockIcon));
  tveLoginBtn.classList.add("security-wall-btn")
  monetisationPrimaryCTA.classList.add("security-wall-btn")
  monetisationSecondaryCTA.classList.add("security-wall-btn")
  tveLoginBtn.classList.add("security-wall-btn")
  tveLoginBtn.classList.add("site-cta-background-color")
  tveLoginBtn.classList.add("security-btn-red")
  tveLoginBtn.innerText = metadataMap?.connectTVProviderText || "Connect TV Provider"
  securityMessage.innerText = metadataMap?.multipleMonetisationText || "Watch Live Games"
  securityWall.classList.add("security-wall")
  getStartedBtn.style.backgroundColor = backgroundColor;
  getStartedBtn.style.color = textColor;
  getStartedBtn.style.border = `${border.width} solid ${border.color}`
  getStartedBtn.style.fontWeight = 900;
  const AuthenticationStore = await localforage.getItem('AuthenticationStore')
  if (!isPlayable) securityWall.classList.add("b-screen")
  let user = AuthenticationStore?.user

  // TVOD Design
  let hardWallWrapper = document.createElement('div')
  let hardwallButtonWrapper = document.createElement("div")
  let chooseMonetisationText = document.createElement('h1')
  chooseMonetisationText.innerText = metadataMap?.chooseMonetisationOptionText
  hardWallWrapper.classList.add("hardwall-wrapper")
  hardwallButtonWrapper.classList.add("hardwall-btn-wrapper")
  monetisationPrimaryCTA.classList.add("site-cta-background-color")
  hardWallWrapper.appendChild(chooseMonetisationText)
  hardWallWrapper.appendChild(hardwallButtonWrapper)


  let plansObj = {}
  let svodCounter = 0
  let rentCounter = 0
  let buyCounter = 0
  samplePlansData?.map((plan,i) => {
      let planDetails = plan?.planDetails?.length ? plan?.planDetails[0] : []
      if (plan?.monetizationModel === "SVOD"){
        svodCounter++
        plansObj[`SVOD-${svodCounter}`] = {
        title : planDetails?.title,
        subTitle : metadataMap?.oneTimePurchaseText,
        amount : planDetails?.recurringPaymentAmount,
        currency : planDetails?.recurringPaymentCurrencyCode
      }
    }
    if (plan?.monetizationModel === "TVOD"){
      // pending handling of plans based on plans purchase types from BE
      if (plan?.purchaseType === "Rent") {
        rentCounter++
        plansObj[`Rent-${rentCounter}`] = {
          title : planDetails?.title,
          subTitle : metadataMap?.oneTimePurchaseText,
          amount : planDetails?.recurringPaymentAmount,
          currency : planDetails?.recurringPaymentCurrencyCode
        }
      }else {
        buyCounter++
        plansObj[`Buy-${buyCounter}`] = {
          title : planDetails?.title,
          subTitle : metadataMap?.oneTimePurchaseText,
          amount : planDetails?.recurringPaymentAmount,
          currency : planDetails?.recurringPaymentCurrencyCode
        }
      }
    }
  })
  ///////
  if (videoWrapper && videoWrapper[0] && vlContainer) {
    securityWall.appendChild(lockIconDiv)
    securityWall.appendChild(securityMessage)
    if (modalType === "SVOD+TVE") {
      let serviceTypes = handleSeviceTypes()
      if(serviceTypes.TVE) securityWall.appendChild(tveLoginBtn)
      if(serviceTypes.SVOD) securityWall.appendChild(monetisationPrimaryCTA)
    } else if (modalType === "FREE_LOGIN" && !user) {
      securityMessage.innerText = metadataMap?.loginRequiredToWatchContentErrorText || "Login Required to Watch Content"
      securityWall.appendChild(getStartedBtn)
    } else if (modalType === "EMAIL_REQUIRED" && !user) {
      securityMessage.innerText = metadataMap?.emailRequiredToWatchContentText || "Email Required to Watch Content"
      securityWall.appendChild(getStartedBtn)
    }else if (modalType === "SVOD") {
      let svodPlan = plansObj[`SVOD-1`]
      monetisationPrimaryCTA.innerHTML = `<div tabIndex={0} class="cta-text-wrapper"><p>${svodPlan?.title}</p><p>${svodPlan?.amount} ${svodPlan?.currency}</p></div>`
      securityMessage.innerText = metadataMap?.purchaseMonetisationText
      hardwallButtonWrapper.appendChild(monetisationPrimaryCTA)
    } else if (modalType === "TVOD") {
      monetisationPrimaryCTA.innerText = metadataMap?.buyEventPass
      if (priorityCTAObj?.primaryCTA === "Rent") {
        let tvodPlan = plansObj[`Rent-1`]
        monetisationPrimaryCTA.innerHTML = `<div tabIndex={0} class="cta-text-wrapper"><p>${metadataMap?.buyEventPass}</p><p>${tvodPlan?.amount} ${tvodPlan?.currency}</p></div>`
      } else {
        let tvodPlan = plansObj[`Buy-1`]
        monetisationPrimaryCTA.innerHTML = `<div tabIndex={0} class="cta-text-wrapper"><p>${metadataMap?.buyEventPass}</p><p>${tvodPlan?.amount} ${tvodPlan?.currency}</p></div>`
      }
      hardwallButtonWrapper.appendChild(monetisationPrimaryCTA)
    } else if (modalType === "SVOD+TVOD") {
      //SVOD and TVOD based on priority btns check
      if (priorityCTAObj?.primaryCTA === "SVOD") {
        let svodPlan = plansObj[`SVOD-1`]
        monetisationPrimaryCTA.innerHTML = `<div tabIndex={0} class="cta-text-wrapper"><p>${svodPlan?.title}</p><p>${svodPlan?.amount} ${svodPlan?.currency}</p></div>`
        if (priorityCTAObj?.secondaryCTA === "Rent") {
          const tvodPlan = plansObj["Rent-1"]
          monetisationSecondaryCTA.innerHTML = `<div tabIndex={0} class="cta-text-wrapper"><p>${metadataMap?.buyEventPass}</p><p>${tvodPlan?.amount} ${tvodPlan?.currency}</p></div>`
        } else {
          let tvodPlan = plansObj[`Buy-1`]
          monetisationSecondaryCTA.innerHTML = `<div tabIndex={0} class="cta-text-wrapper"><p>${metadataMap?.buyEventPass}</p><p>${tvodPlan?.amount} ${tvodPlan?.currency}</p></div>`
        }
      }
      if (priorityCTAObj?.secondaryCTA === "SVOD") {
        let svodPlan1 = plansObj[`SVOD-1`]
        let svodPlan2 = plansObj[`SVOD-2`]
        monetisationPrimaryCTA.innerHTML = `<div tabIndex={0} class="cta-text-wrapper"><p>${svodPlan1?.title}</p><p>${svodPlan1?.amount} ${svodPlan1?.currency}</p></div>`
        monetisationSecondaryCTA.innerText = `<div tabIndex={0} class="cta-text-wrapper"><p>${svodPlan2?.title}</p><p>${svodPlan2?.amount} ${svodPlan2?.currency}</p></div>`
      if (priorityCTAObj?.primaryCTA === "Rent") {
        let tvodPlan = plansObj[`Rent-1`]
        monetisationSecondaryCTA.innerHTML = `<div tabIndex={0} class="cta-text-wrapper"><p>${metadataMap?.buyEventPass}</p><p>${tvodPlan?.amount} ${tvodPlan?.currency}</p></div>`
        if (priorityCTAObj?.secondaryCTA === "SVOD") {
          let svodPlan = plansObj[`SVOD-1`]
          monetisationPrimaryCTA.innerHTML = `<div tabIndex={0} class="cta-text-wrapper"><p>${svodPlan?.title}</p><p>${svodPlan?.amount} ${svodPlan?.currency}</p></div>`
        }
      } else {
        let tvodPlan = plansObj[`Buy-1`]
        monetisationSecondaryCTA.innerHTML = `<div tabIndex={0} class="cta-text-wrapper"><p>${metadataMap?.buyEventPass}</p><p>${tvodPlan?.amount} ${tvodPlan?.currency}</p></div>`
        if (priorityCTAObj?.secondaryCTA === "SVOD") {
          let svodPlan = plansObj[`SVOD-1`]
          monetisationPrimaryCTA.innerHTML = `<div tabIndex={0} class="cta-text-wrapper"><p>${svodPlan?.title}</p><p>${svodPlan?.amount} ${svodPlan?.currency}</p></div>`
        }
      }
    }


    hardwallButtonWrapper.appendChild(monetisationPrimaryCTA)
    hardwallButtonWrapper.appendChild(monetisationSecondaryCTA)
    let plansLength = Object.keys(plansObj).length
    if (plansLength > 2) {
      let moreOptionCTA = document.createElement("div")
      moreOptionCTA.classList.add("security-wall-btn")
      moreOptionCTA.classList.add("more-option-cta")
      moreOptionCTA.innerText = metadataMap?.morePurchaseText
      moreOptionCTA.addEventListener('click',() => handleSubscriptionPopup(plansObj))
      hardwallButtonWrapper.appendChild(moreOptionCTA)
    //cta styles
    handleCtaStyles({monetisationPrimaryCTA,monetisationSecondaryCTA,moreOptionCTA})
    }
    //cta styles
    handleCtaStyles({monetisationPrimaryCTA,monetisationSecondaryCTA})
  } else {
      securityWall.appendChild(tveLoginBtn)
    }
    videoWrapper[0].appendChild(securityWall)
    videoWrapper[0].appendChild(hardWallWrapper)
    if (isPlayable) {
      let errorWall = document.getElementsByClassName("error-wall-wrapper")
      if (errorWall?.[0]) {
        if(window.player){
          window.player.pause();
          if(isDash){
            let dashController = document.querySelector('#videoController');
            if(dashController) dashController.style.visibility='hidden'
          }
          let el=document.querySelector('.videoContainer')
          if(el)
          el.style.visibility='hidden'
        }else 
          VLPlayerCore().dispose(playerId)
      }else {
        VLPlayerCore().disableControls(playerId)
        setTimeout(() => {
          VLPlayerCore().pause(playerId)
        },0)
      }
    }

    tveLoginBtn.addEventListener("click", () => {
      localforage.setItem("isRedirected", { path: `${location?.pathname}${location.search}`, redirect: true, isDetailPage : true })
      if (user) {
        switchBetweenPages();
        navigate("/tve")
      } else {
        switchBetweenPages();
        navigate("/authentication")
      }
    })
    getStartedBtn.addEventListener("click", () => {
      localforage.setItem("isRedirected", { path: `${location?.pathname}${location.search}`, redirect: true, isDetailPage : true })
      sessionStorage.setItem("contentPlanIds", contentPlanIds)
      if (user) {
        if (modalType === "FREE_LOGIN" || modalType === "EMAIL_REQUIRED") return
        else{
          switchBetweenPages();
          navigate("/viewplans")
        } 
      } else {
        switchBetweenPages();
        navigate("/authentication")
      }
    })
  }
}

export const handleSecurityWall = (data) => {
  let securityWall = document.querySelector(".security-wall")
  let controlBar = document.querySelector(".vjs-control-bar")
  let vjsPlayBtn = document.querySelector(".vjs-big-play-button")
  if (securityWall) {
    securityWall.remove()
    if (controlBar?.style && vjsPlayBtn?.style) {
    controlBar.style.visibility = "visible !important"
    vjsPlayBtn.style.visibility = "visible !important"
  }
  }
  let { VLPlayerCore, playerId, navigate, metadataMap, monetizationModels, contentPlanIds, isPlayable, containerClass, detailPageClass, monetisationPlansIds, errorDetails, errorMsg, priorityCTAObj, isLoginRequired, isEmailRequired} = data
  videoContainer = containerClass
  detailPageContainer = detailPageClass
  localforage.getItem('AuthenticationStore')
    .then((AuthenticationStore) => {

      let user = AuthenticationStore?.user
      let isTveLoggedIn = user?.tveProvider || user?.tveMetadata?.tveProvider
      let isSubscribed = user?.isSubscribed
      let securityParameters = {VLPlayerCore, playerId, navigate, metadataMap, monetisationType : null, contentPlanIds, isPlayable, priorityCTAObj}
      if (!user) {
        if (isLoginRequired) {
          handlePaywallAccess({...securityParameters, 
            monetisationType: "FREE_LOGIN" 
          })
          return pubsub.publish('paywall', true);
        }
        if (isEmailRequired) {
          handlePaywallAccess({...securityParameters, 
            monetisationType: "EMAIL_REQUIRED" 
          })
          return pubsub.publish('paywall', true);
        }
        if (!isPlayable) {
          if (errorDetails?.errorCode !== "FORBIDDEN" && errorDetails?.errorCode !== "CANT_ACCESS_TVE_CONTENT") {
            if (errorMsg) {
              handleErrorWall(null,errorMsg)
              pubsub.publish('paywall', true);
              return
            }
            handleErrorWall(errorDetails,null, user?.hbaMetadata,metadataMap)
            pubsub.publish('paywall', true);
            return;
          }
        }
        let monetizationModalByCountry = window?.app_data?.monetisationModelByCountry
        if (monetizationModels?.length && monetizationModalByCountry != "FREE") {
          let monetisationTypes = []
          if (monetizationModels[0]?.type) {
            monetisationTypes = monetizationModels?.map((plan) => plan?.type)
          }else {
            monetisationTypes = monetizationModels
          }
          if ((monetisationTypes?.includes("SVOD") && monetisationTypes?.includes("TVE")) || monetisationTypes?.includes("SVOD+TVE")) {
            securityParameters.monetisationType = "SVOD+TVE"
            handlePaywallAccess(securityParameters)
            return
          }
          if ((monetizationModels?.includes("SVOD") && monetizationModels?.includes("TVOD")) || monetizationModels?.includes("SVOD+TVOD")) {
            securityParameters.monetisationType = "SVOD+TVOD"
            handlePaywallAccess(securityParameters)
            return
          }
          // For AVOD + TVE or AVOD + SVOD , always TVE/SVOD will have preference 

          if (monetisationTypes?.includes("SVOD")) {
            securityParameters.monetisationType = "SVOD"
            handlePaywallAccess(securityParameters)
            return;
          }
          if (monetisationTypes?.includes("TVE")) {
            securityParameters.monetisationType = "TVE"
            handlePaywallAccess(securityParameters)
            return
          }
          if (monetisationTypes?.includes("AVOD")) {
            pubsub.publish('paywall', false)
            return;
          }
          if (monetisationTypes?.includes("FREE")) {
            pubsub.publish('paywall', false)
            return;
          }
        } else {
          pubsub.publish('paywall', false);
          return;
        }
      }
      if (!isPlayable) {
        if ((errorDetails?.errorCode !== "FORBIDDEN" && errorDetails?.errorCode !== "CANT_ACCESS_TVE_CONTENT")) {
          if (errorMsg) {
            handleErrorWall(null,errorMsg)
            pubsub.publish('paywall', true);
            return
          }
          handleErrorWall(errorDetails,null, user?.hbaMetadata,metadataMap)
          pubsub.publish('paywall', true);
          return;
        }
        if (monetizationModels?.length) {
          if ((monetizationModels?.includes("SVOD") && monetizationModels?.includes("TVE")) || monetizationModels?.includes("SVOD+TVE")) {
            if (isSubscribed || isTveLoggedIn) {
                handleErrorWall(errorDetails)
                pubsub.publish('paywall', true)
                return
              }
            securityParameters.monetisationType = "SVOD+TVE"
            handlePaywallAccess(securityParameters)
            return
          }
          if (monetizationModels?.includes("SVOD")) {
            if (isSubscribed) {
              handleErrorWall(errorDetails)
              pubsub.publish('paywall', true)
              return
            }
            securityParameters.monetisationType = "SVOD"
            handlePaywallAccess(securityParameters)
            return
          }
          if (monetizationModels?.includes("TVE")) {
            if (isTveLoggedIn) {
              handleErrorWall(errorDetails)
              pubsub.publish('paywall', true)
              return
            }
            securityParameters.monetisationType = "TVE"
            handlePaywallAccess(securityParameters)
            return
          }
          if (monetizationModels?.includes("TVOD")) {
            // if (isTveLoggedIn) { //add a tvod plan check here
            //   handleErrorWall(errorDetails)
            //   pubsub.publish('paywall', true)
            //   return
            // }
            securityParameters.monetisationType = "TVOD"
            handlePaywallAccess(securityParameters)
            return
          }
          if (monetizationModels?.includes("FREE")) {
            handleErrorWall(errorDetails)
            pubsub.publish('paywall', true)
            return;
          }
        }else{
          handleErrorWall(errorDetails)
          pubsub.publish('paywall',true)
          return
        }
      }
      if(isPlayable){
        pubsub.publish('paywall', false)
        return
      }
      // if (((!isSubscribed || !isTveLoggedIn) && isPlayable) || (isSubscribed && isTveLoggedIn && isPlayable)) {
      //   if (monetizationModels?.length > 0) {
      //     let isPlanSubscribed = handlePlansCheck(monetisationPlansIds, user)
      //     monetizationModels?.map((models, i) => {
      //       // if (models?.type === "FREE") {
      //       //   pubsub.publish('paywall', false)
      //       //   return
      //       // }
      //       if (models?.type === "SVOD" || models?.type === "TVE" || models?.type === "SVOD+TVE" || models?.type === "FREE" || models?.type === "AVOD") modalsArray.push(models?.type)
      //       if (i === monetizationModels?.length - 1) {
      //         if (modalsArray.includes("FREE")) {
      //           pubsub.publish('paywall', false)
      //           return
      //         }
      //         if ((modalsArray.includes("SVOD") && modalsArray.includes("TVE")) || modalsArray.includes("SVOD+TVE")) {
      //           if (isSubscribed && isPlanSubscribed) {
      //             pubsub.publish('paywall', false)
      //             return
      //           }
      //           if (isTveLoggedIn) {
      //             pubsub.publish('paywall', false)
      //             return
      //           }
      //           securityParameters.monetisationType = "SVOD+TVE"
      //           handlePaywallAccess(securityParameters)
      //           return
      //         }
      //         if (modalsArray.includes("SVOD")) {
      //           if (isSubscribed && isPlanSubscribed) {
      //             pubsub.publish('paywall', false)
      //             return
      //           }
      //           securityParameters.monetisationType = "SVOD"
      //           handlePaywallAccess(securityParameters)
      //           return
      //         }
      //         if (modalsArray.includes("TVE")) {
      //           if (isTveLoggedIn) {
      //             pubsub.publish('paywall', false)
      //             return
      //           }
      //           securityParameters.monetisationType = "TVE"
      //           handlePaywallAccess(securityParameters)
      //           return
      //         }

      //         if (modalsArray.includes("AVOD")) {
      //           pubsub.publish('paywall', false)
      //           return
      //         } 
      //       }
      //     })
      //   }else {
      //     pubsub.publish('paywall',false)
      //     return
      //   }
      // }

    })

}

const handleGeoLocationError = (hba,metadataMap,errorMsg) => {
  let geoLocationWall = document.createElement("div")
  let securityTitle = document.createElement("h1")
  let securityMessage = document.createElement("p")
  let faqDisclaimer = document.createElement("p")
  geoLocationWall.classList.add("geo-location-wall")
  fetchHbaData().then((locationData) => {
    if (locationData?.byCoordinates) {
      if (errorMsg === "contentGeoRestricted") {
        securityMessage.innerText = metadataMap?.geoLocationEnabledText 
      }else {
        securityMessage.innerText = metadataMap?.geoLocationDisabledText
      }
    }else if (!hba?.enabled) {
      securityMessage.innerText = metadataMap?.geoLocationDisabledText
    }else {
      securityMessage.innerText = metadataMap?.geoLocationEnabledText
    }
    securityTitle.innerText = metadataMap?.outsideViewingAreaText || "Outside of Viewing Area"
    faqDisclaimer.classList.add('faq-disclaimer')

    const faqLink = getFaqLink()
    if(faqLink){
      const anchor = document.createElement('a');
      anchor.href = faqLink
      anchor.target = "_blank"
      anchor.textContent = `${metadataMap?.faqDisclaimerText || "For more information, visit our FAQs"}`
      faqDisclaimer.appendChild(anchor)
    } else{
      faqDisclaimer.innerText = metadataMap?.faqDisclaimerText || "For more information, visit our FAQs"
    }

    faqDisclaimer.innerText = metadataMap?.faqDisclaimerText || "For more information, visit our FAQs"
    geoLocationWall.appendChild(securityTitle)
    geoLocationWall.appendChild(securityMessage)
    geoLocationWall.appendChild(faqDisclaimer)
  }).catch((e) => {
    console.log(e)
  })
  return {
    geoLocation : true,
    geoLocationWall,
  }
}
const handleErrorMessage = (errorDetails,hba,metadataMap) => {
  let camelCaseErrorCode = errorDetails?.errorCode
  if (camelCaseErrorCode?.includes("_")) {
    const errorCodeArray = errorDetails?.errorCode?.split("_");
    camelCaseErrorCode = errorCodeArray?.map((str, i) => {
      if (i === 0) {
        return str?.toLowerCase();
      } else {
        return str?.charAt(0).toUpperCase() + str?.slice(1).toLowerCase();
      }
    }).join("");
  }
  if (camelCaseErrorCode === "contentGeoRestricted" || camelCaseErrorCode === "contentGeoRestrictedByHBA") {
    let geoLocationDetails = handleGeoLocationError(hba,metadataMap,camelCaseErrorCode)
    if (geoLocationDetails?.geoLocation) return geoLocationDetails
  }
  let genericMessageList = window?.app_data?.appcmsMain?.genericMessages
  if (genericMessageList[`${camelCaseErrorCode}`]) return genericMessageList[`${camelCaseErrorCode}`]
  else return errorDetails?.errorMessage
}

const handleErrorWall = (errorDetails,errorMsg,hba,metadataMap) => {
  let securityWall = document.createElement("div")
  let securityMessage = document.createElement("h1")
  let videoWrapper = document.getElementsByClassName("video-thumbnail") || document.getElementsByClassName("video-js videoEl")
  securityWall.classList.add("security-wall")
  securityMessage.style.textAlign = "center"
  let lockIconDiv = document.createElement("div");
  lockIconDiv.appendChild(parseSvgString(lockIcon));
  let errorMessage = errorMsg
  if (!errorMsg) {
    errorMessage = handleErrorMessage(errorDetails,hba,metadataMap)
    if (errorMessage?.geoLocation) {
      securityWall.appendChild(errorMessage?.geoLocationWall)
      if (videoWrapper?.length) videoWrapper[0].appendChild(securityWall)
      return
    }
  }
  securityMessage.innerText = errorMessage
  securityWall.appendChild(lockIconDiv)
  securityWall.appendChild(securityMessage)
  if (videoWrapper?.length && (errorDetails?.errorCode || errorMsg)) videoWrapper[0].appendChild(securityWall)
}

const handlePaywallAccess = (securityParameters) => {
  let { VLPlayerCore, playerId, navigate, metadataMap, monetisationType, contentPlanIds, isPlayable, priorityCTAObj,onPlayerWall } = securityParameters
  if (!monetisationType) {
    pubsub.publish('paywall', false)
    return 
  }
  let isAccessEnabled = false
  let serviceTypes = handleSeviceTypes()
  if (serviceTypes.SVOD && serviceTypes.TVE) isAccessEnabled = true
  if (serviceTypes.SVOD && !serviceTypes.TVE && monetisationType !== "TVE") isAccessEnabled = true
  if (!serviceTypes.SVOD && serviceTypes.TVE && monetisationType !== "SVOD") isAccessEnabled = true
  if (!serviceTypes.FREE_LOGIN) isAccessEnabled = true
  if (!serviceTypes.EMAIL_REQUIRED) isAccessEnabled = true
  if (isAccessEnabled) {
    watchLiveSecurityWall(VLPlayerCore, playerId, navigate, metadataMap, monetisationType, contentPlanIds, isPlayable, priorityCTAObj, onPlayerWall)
    pubsub.publish('paywall', true)
    return;
  }
  pubsub.publish('paywall', false)
  return
}

const handlePlansCheck = (monetisationPlansIds, user) => {
  let userPlanId = user?.subscription?.subscriptionInfo?.planId
  if (!user) return false
  if (user?.isSubscribed) {
    let isSvodPlanSubscribed = monetisationPlansIds?.includes("svodAll")
    return isSvodPlanSubscribed
  }
  if ((user?.tveProvider || user?.tveMetadata?.tveProvider) && user?.canAuthenticate) {
    let isTvePlanSubscribed = monetisationPlansIds?.includes("tveAll")
    return isTvePlanSubscribed
  }
  let isPlanSubscribed = monetisationPlansIds?.includes(userPlanId)
  return isPlanSubscribed
}

export const checkFutureDate = (targetDate) => {
  if ((targetDate * 1000) - Date.now() > 0) {
    return true
  } else {
    return false
  }
}

export const getPreviewId = (slide, currentState) => {
  let contentType = slide?.gist?.contentType?.toLowerCase()
  let gameState = currentState || slide?.currentState
  let isPreviewAvailable = slide?.preview?.id
  let liveStreamId = slide?.livestreams && slide.livestreams.length > 0 && slide.livestreams[0]?.id
  let previewId = isPreviewAvailable
  let queryString = window.location.search;
  let urlParams = new URLSearchParams(queryString);
  let videoType = gameState === "default" ? "preview" : "others"
  // if(urlParams.get("popup")){
  //   return { id: liveStreamId, type: "live",videoType }
  // }
  if ((gameState === "default" || gameState === "end") && isPreviewAvailable) {
    return { id: previewId, type: "preview", videoType }
  } else if (gameState != "default" && liveStreamId) {
    return { id: liveStreamId, type: "live",videoType }
  } else { return { id: null, type: null ,videoType} }
}


export const checkTveAuthZ = ({videoTitle,assetID,planChannelIds}) => {
  let tveSettings = window.app_data.appcmsPlatform.tveSettings
  let requestorID = tveSettings?.requestorID
  let resourceID = tveSettings?.resourceID
  let resources = tveSettings?.resourceIds
  const adobeVersion = window?.app_data?.appcmsPlatform?.tveSettings?.version || "v1"
  if(adobeVersion == 'v1'){
    if(planChannelIds?.length > 0 && resources?.length > 0){
      for(let channelIdx = 0; channelIdx < planChannelIds.length; channelIdx++ ){
        // checking for each authz call and attaching a new subscription
          window?.AE?.checkAuthorization(`<rss version=\"2.0\"><channel><title>${planChannelIds[channelIdx]}</title><item><title>${videoTitle}</title><guid>${assetID}</guid></item></channel></rss>`)
      }
      return new Promise((resolve, reject) => { 
        pubsub.subscribe('tveAuthz', (data) => {
          if (data?.inToken) {
            resolve(data)
          }
          setTimeout(() => {
            reject("TVE Authorize error ")
          },5000)
        })
       })
    }else{
      window?.AE?.checkAuthorization(`<rss version=\"2.0\"><channel><title>${resourceID}</title><item><title>${videoTitle}</title><guid>${assetID}</guid></item></channel></rss>`)
      return new Promise((resolve, reject) => {
          pubsub.subscribe('tveAuthz', (data) => {
            if (data?.inRequestErrorCode) {
              reject("TVE Authorize error")
            }
            if (data?.inToken) {
              resolve(data)
            }
          })
       })
    }
  }else{
    return new Promise((resolve, reject) => {
      const selectedMvpdId= localStorage.getItem('selectedMvpdId')
      createDecisionsAuthorize([resourceID], selectedMvpdId).then((res) => {
        const isAuthorized = res?.authorized
        if(isAuthorized) resolve()
        if(!isAuthorized && res?.error?.code == "authorization_denied_by_mvpd"){
          reject("TVE Authorization denied")
        }
      }).catch((error) => {
        logger('selectedMvpdId checkTveAuthZ:'+ selectedMvpdId,'info', true);
        if (error.response) {
          logger('Error Code Authorize checkTveAuthZ:'+ error.response.status,'info', true);
          logger('Error Message Authorize checkTveAuthZ:'+ error.response?.data?.message,'info', true);
          logger('Error Data Authorize checkTveAuthZ:'+ JSON.stringify(error.response.data), 'info', true);
        } else if (error.request) {
          logger('No response received Authorize checkTveAuthZ:'+ error.request,'info', true);
        } else {
          logger('Axios Error Authorize checkTveAuthZ:'+ error.message,'info', true);
        }
        reject("Playback is not authorized")
        })
   })
  }


}

export const getOrdinal = (number) => {
  if (!number) return '';
   number = Number(number);
   if (isNaN(number)) return '';
   let lastDigit = number % 10;
   let lastTwoDigits = number % 100;
   if ([11, 12, 13].includes(lastTwoDigits)) {
        return number + 'th';
   }
   switch (lastDigit) {
        case 1: return number + 'st';
        case 2: return number + 'nd';
        case 3: return number + 'rd';
        default: return number + 'th';
   }
}

let samplePlansData = [
  {
    "identifier": "livgolfplus_seasonpass",
    "metadata": [],
    "updateDate": "2024-01-24T21:28:59.302Z",
    "addedDate": "2024-01-24T21:28:59.302Z",
    "purchaseType" : "SVOD",
    "featureSetting": {
      "numberOfAllowedStreams": 100,
      "contentConsumption": [
        "web",
        "ios",
        "android",
        "roku",
        "fireTv",
        "appleTv",
        "samsung",
        "lg",
        "androidTv",
        "tivo",
        "xBox",
        "miTv",
        "corpus",
        "vizioTv"
      ],
      "includingAds": false,
      "isHdStreaming": true,
      "isBeamingAllowed": true,
      "isDownloadAllowed": true,
      "numberOfAllowedDevices": 100
    },
    "scheduledFromDate": "2023-04-05T16:17:00.000Z",
    "description": "Season Pass",
    "site": "liv-golf_PLAN",
    "planDetails": [
      {
        "isRentEnabled": false,
        "recurringPaymentAmount": 30,
        "visible": true,
        "redirectUrl": "",
        "displayStrikeThroughPrice": false,
        "hidePlanPrice": false,
        "scheduledFromDate": 1680711420000,
        "description": "Season Pass",
        "numberOfAllowedDevices": 100,
        "title": "Season Pass",
        "isPurchaseEnabled": false,
        "numberOfAllowedStreams": 100,
        "features": [
          {
            "valueType": "string",
            "value": "Y",
            "textToDisplay": "Full Access to 2023 season"
          },
          {
            "valueType": "string",
            "value": "Y",
            "textToDisplay": "Renewed Yearly"
          }
        ],
        "isDefault": false,
        "carrierBillingProviders": [],
        "scheduledToDate": null,
        "countryCode": "IN",
        "recurringPaymentCurrencyCode": "USD",
        "supportedDevices": [
          "android_tablet",
          "android_tv",
          "oneplus_tv",
          "web_browser",
          "ios_ipad",
          "ios_phone",
          "android_phone",
          "jio_stb",
          "ios_apple_tv",
          "roku_box",
          "fire_tv",
          "smart_tv_samsung",
          "smart_tv_lg",
          "windows_xbox",
          "mi_tv",
          "corpus",
          "vizioTv"
        ],
        "tnCPoints": [],
        "featureDetails": [
          {
            "valueType": "string",
            "value": "Y",
            "textToDisplay": "Full Access to 2023 season"
          },
          {
            "valueType": "string",
            "value": "Y",
            "textToDisplay": "Renewed Yearly"
          }
        ]
      }
    ],
    "objectKey": "monetizationPlan",
    "renewable": true,
    "renewalCycleType": "YEAR",
    "name": "2023 Season Pass",
    "renewalCyclePeriodMultiplier": 1,
    "siteOwner": "liv-golf",
    "id": "51ac6074-6537-4692-b2f3-b13fb94236f0",
    "planDisplayOrder": 1,
    "monetizationModel": "SVOD",
    "planOffers": [
      {
        "isDefault": false,
        "offerId": "2dac916a-a259-4449-a955-0d936760fbf9"
      }
    ]
  },
  {
    "identifier": "SVOD_123",
    "metadata": [],
    "updateDate": "2024-02-01T10:42:29.411Z",
    "addedDate": "2024-02-01T10:42:29.411Z",
    "purchaseType" : "Rent",
    "featureSetting": {
      "numberOfAllowedStreams": 1,
      "contentConsumption": [
        "web",
        "ios",
        "android",
        "roku",
        "fireTv",
        "appleTv",
        "samsung",
        "lg",
        "androidTv",
        "tivo",
        "xBox",
        "miTv",
        "corpus",
        "vizioTv"
      ],
      "includingAds": false,
      "isHdStreaming": true,
      "isBeamingAllowed": true,
      "isDownloadAllowed": true,
      "numberOfAllowedDevices": 3
    },
    "scheduledFromDate": "2023-10-13T08:59:00.000Z",
    "description": "This is test",
    "site": "liv-golf_PLAN",
    "planDetails": [
      {
        "isRentEnabled": false,
        "recurringPaymentAmount": 1,
        "visible": true,
        "redirectUrl": "",
        "displayStrikeThroughPrice": false,
        "hidePlanPrice": false,
        "scheduledFromDate": 1697187540000,
        "numberOfAllowedDevices": 3,
        "isPurchaseEnabled": false,
        "numberOfAllowedStreams": 1,
        "features": [],
        "title": "TVOD-canada",
        "isDefault": false,
        "carrierBillingProviders": [],
        "scheduledToDate": null,
        "countryCode": "IN",
        "recurringPaymentCurrencyCode": "INR",
        "supportedDevices": [
          "android_tablet",
          "android_tv",
          "oneplus_tv",
          "web_browser",
          "ios_ipad",
          "ios_phone",
          "android_phone",
          "jio_stb",
          "ios_apple_tv",
          "roku_box",
          "fire_tv",
          "smart_tv_samsung",
          "smart_tv_lg",
          "windows_xbox",
          "mi_tv",
          "corpus",
          "vizioTv"
        ],
        "tnCPoints": [],
        "featureDetails": []
      }
    ],
    "objectKey": "monetizationPlan",
    "renewable": true,
    "renewalCycleType": "MONTH",
    "name": "SVOD_123",
    "renewalCyclePeriodMultiplier": 1,
    "siteOwner": "liv-golf",
    "id": "ec45486f-bf4b-4a97-9723-2c135192f9ad",
    "planDisplayOrder": 1,
    "monetizationModel": "TVOD",
    "planOffers": [],
    "scheduledToDate": null
  },
  {
    "identifier": "svod",
    "metadata": [],
    "updateDate": "2023-08-09T13:48:28.470Z",
    "addedDate": "2023-08-09T13:48:28.470Z",
    "purchaseType" : "SVOD",
    "featureSetting": {
      "numberOfAllowedStreams": 2,
      "contentConsumption": [
        "web",
        "ios",
        "android",
        "roku",
        "fireTv",
        "appleTv",
        "samsung",
        "lg",
        "androidTv",
        "tivo",
        "xBox",
        "miTv",
        "corpus",
        "vizioTv"
      ],
      "includingAds": false,
      "isHdStreaming": true,
      "isBeamingAllowed": true,
      "isDownloadAllowed": true,
      "numberOfAllowedDevices": 2
    },
    "scheduledFromDate": "2023-05-26T11:58:00.000Z",
    "description": "hjds",
    "site": "liv-golf_PLAN",
    "planDetails": [
      {
        "isRentEnabled": false,
        "recurringPaymentAmount": 100,
        "visible": true,
        "redirectUrl": "",
        "displayStrikeThroughPrice": false,
        "hidePlanPrice": false,
        "scheduledFromDate": 1685102280000,
        "numberOfAllowedDevices": 2,
        "title": "h",
        "isPurchaseEnabled": false,
        "numberOfAllowedStreams": 2,
        "features": [],
        "isDefault": false,
        "carrierBillingProviders": [],
        "scheduledToDate": null,
        "countryCode": "IN",
        "restriction": [],
        "recurringPaymentCurrencyCode": "INR",
        "supportedDevices": [
          "android_tablet",
          "android_tv",
          "oneplus_tv",
          "web_browser",
          "ios_ipad",
          "ios_phone",
          "android_phone",
          "jio_stb",
          "ios_apple_tv",
          "roku_box",
          "fire_tv",
          "smart_tv_samsung",
          "smart_tv_lg",
          "windows_xbox",
          "mi_tv",
          "corpus",
          "vizioTv"
        ],
        "tnCPoints": [],
        "featureDetails": []
      }
    ],
    "objectKey": "monetizationPlan",
    "renewable": true,
    "renewalCycleType": "YEAR",
    "name": "SVOD",
    "renewalCyclePeriodMultiplier": 1,
    "siteOwner": "liv-golf",
    "id": "033f9b28-d171-4e07-a181-5ddf790606e5",
    "monetizationModel": "SVOD",
    "planOffers": []
  }
]